import * as i0 from '@angular/core';
import { EventEmitter, forwardRef, Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i2 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from 'ng2-nouislider';
import { NouisliderModule } from 'ng2-nouislider';
const _c0 = ["slider"];
function RangeSliderComponent_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 4);
  }
}
const _c1 = a0 => ({
  enableTooltipOnDrag: a0
});
var PipsType;
(function (PipsType) {
  PipsType[PipsType["None"] = -1] = "None";
  PipsType[PipsType["NoValue"] = 0] = "NoValue";
  PipsType[PipsType["LargeValue"] = 1] = "LargeValue";
  PipsType[PipsType["SmallValue"] = 2] = "SmallValue";
})(PipsType || (PipsType = {}));
class RangeSliderComponent {
  constructor(changeDetectorRef) {
    this.changeDetectorRef = changeDetectorRef;
    /**
     * get the max value in the range slider
     */
    this.max = 30;
    /**
     * get the min value in the range slider
     */
    this.min = -30;
    /**
     * get the step value for every move in the range slider
     */
    this.step = 1;
    /**
     * get the startPoints for every drag and drop in the range slider
     */
    this.startPoints = [0];
    /*
     * enable or disable tooltip
     * */
    this.enableTooltip = true;
    /*
     * enable tooltip on drag
     * */
    this.enableTooltipOnDrag = false;
    /*
     *  get mode (count/steps/range) for slider.
     * */
    this.mode = 'count';
    /*
     * get density for markers in between pips
     * */
    this.density = 1.8;
    /*
     * get number of marker values to be displayed
     * */
    this.markerValues = 13;
    /*
     * get whether slider should be stepped or not
     * */
    this.stepped = true;
    /*
     * get behaviour of slider
     * */
    this.behaviour = 'drag';
    /*
     * provide suffix for marker labels
     * */
    this.markerSuffix = '';
    /*
     * get number of pips and their connectivity
     * */
    this.connect = false;
    /*
     * get colour classes for slider
     * */
    this.colorClasses = [];
    /*
     * get position for highlighting a position on slider
     * */
    this.highlightPosition = null;
    /*
     * get title for highlighted position on slider
     * */
    this.highlightedMarkerTitle = '';
    /*
     * disable/ enable pivots
     * */
    this.disabled = false;
    this.enableArrow = false;
    /**
     * enable / disable round touch button
     */
    this.enableRoundButton = true;
    /**
     * emit endEvent
     */
    this.endEvent = new EventEmitter();
    /**
     * emit setEvent
     */
    this.changeEvent = new EventEmitter();
    this.oldColorClass = [];
    /**
     * The registered callback function called when a change event occurs on the numeric selector element.
     */
    this.onChangedCallback = _ => {}; // eslint-disable-line @typescript-eslint/no-unused-vars
    /**
     * The registered callback function called when a blur event occurs on the numeric selector element.
     */
    this.onTouchedCallback = () => {}; // eslint-disable-line @typescript-eslint/no-unused-vars
  }
  ngOnChanges(changes) {
    setTimeout(() => {
      if (this.slider && changes) {
        const newOptions = {
          ...this.slider.slider.options
        };
        newOptions.range.max = changes.max ? changes.max.currentValue : newOptions.range.max;
        newOptions.range.min = changes.min ? changes.min.currentValue : newOptions.range.min;
        newOptions.connect = changes.connect ? changes.connect.currentValue : newOptions.connect;
        newOptions.markerValues = changes.markerValues ? changes.markerValues.currentValue : newOptions.markerValues;
        newOptions.mode = changes.mode ? changes.mode.currentValue : newOptions.mode;
        newOptions.density = changes.density ? changes.density.currentValue : newOptions.density;
        newOptions.step = changes.step ? changes.step.currentValue : newOptions.step;
        newOptions.startPoints = changes.startPoints ? changes.startPoints.currentValue : newOptions.startPoints;
        const {
          connect,
          ...optionsWithoutConnect
        } = newOptions;
        this.slider.slider.updateOptions(optionsWithoutConnect, true);
        this.insertClassesNameForHighlightedMarker(true);
        this.changeDetectorRef.detectChanges();
      }
      if (this.highlightPosition !== null && changes.highlightPosition) {
        if (!changes.highlightPosition.firstChange) {
          this.insertClassesNameForHighlightedMarker(false);
          this.changeDetectorRef.detectChanges();
        }
      }
      if (this.colorClasses !== null && changes.colorClasses) {
        if (!changes.colorClasses.firstChange) {
          this.insertClassesNameForColors(false);
          this.changeDetectorRef.detectChanges();
        }
      }
    });
  }
  ngOnInit() {
    this.initialize();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      // adding aria-label for accessibility
      const handle = this.slider.el.nativeElement.querySelectorAll('.noUi-handle');
      handle.forEach(element => {
        element.setAttribute('aria-label', 'drag-handle');
      });
      //adding colorClasses
      if (this.colorClasses !== null) {
        this.insertClassesNameForColors(true);
      }
      //adding class for marker
      if (this.highlightPosition !== null) {
        this.insertClassesNameForHighlightedMarker(true);
      }
      this.insertClassForArrows();
      //adding class for custom round button
      if (this.enableRoundButton) {
        this.setRoundButton();
      }
    });
  }
  /*
   * The function inserts css classes for highlighting a particular value on the slider
   * */
  insertClassesNameForHighlightedMarker(firstChange) {
    if (!firstChange) {
      const prevHighlight = this.slider.el.nativeElement.querySelectorAll('.highlighted-marker-class');
      if (prevHighlight) {
        prevHighlight[0].remove();
      }
    }
    const connect = this.slider.el.nativeElement.querySelectorAll('.noUi-marker');
    for (let i = 0; i < connect.length; i++) {
      if (i === this.highlightPosition) {
        connect[i].insertAdjacentHTML('beforeend', '<div class="highlighted-marker-class">' + '<span class="highlighted-marker-title-class">' + this.highlightedMarkerTitle + '</span></div>');
        break;
      }
    }
  }
  /*
   * The function inserts color classes for slider colors
   * */
  insertClassesNameForColors(firstChange) {
    if (firstChange) {
      const connect = this.slider.el.nativeElement.querySelectorAll('.noUi-connect');
      const classes = this.colorClasses;
      for (let i = 0; i < connect.length; i++) {
        connect[i].classList.add(classes[i]);
        this.oldColorClass.push(classes[i]);
      }
    } else {
      const connect = this.slider.el.nativeElement.querySelectorAll('.noUi-connect');
      const classes = this.colorClasses;
      for (let i = 0; i < connect.length; i++) {
        connect[i].classList.replace(this.oldColorClass[i], classes[i]);
        this.oldColorClass.push(classes[i]);
      }
    }
  }
  /**
   * Add class to convert the touch button into a round button
   */
  setRoundButton() {
    const noUiHandle = this.slider.el.nativeElement.querySelectorAll('.noUi-handle');
    const noUiTouchArea = this.slider.el.nativeElement.querySelectorAll('.noUi-touch-area');
    for (const item of noUiHandle) {
      item.classList.add('no-ui-handler-round');
    }
    for (const item of noUiTouchArea) {
      item.classList.add('no-ui-touch-area-round');
    }
  }
  insertClassForArrows() {
    if (this.enableArrow) {
      let connect = this.slider.el.nativeElement.querySelectorAll('.noUi-base');
      connect[0].insertAdjacentHTML('afterend', '<div class="addRedArrow">');
      connect = this.slider.el.nativeElement.querySelectorAll('.noUi-target');
      connect[0].insertAdjacentHTML('beforeend', '<div class="addGreenArrow">');
    }
  }
  initialize() {
    this.someKeyboardConfig = {
      connect: this.connect,
      start: this.startPoints,
      step: this.step,
      tooltips: this.enableTooltip,
      format: {
        to: value => {
          value = Math.round(value / this.step) * this.step;
          if (this.tooltipFormatter) {
            return this.tooltipFormatter(value);
          } else {
            return value;
          }
        },
        from: value => {
          if (!isNaN(value)) {
            return parseFloat(value);
          }
          return value;
        }
      },
      margin: this.step,
      range: this.range || {
        min: this.min,
        max: this.max
      },
      pips: this.pips ? this.pips : {
        mode: this.mode,
        density: this.density,
        values: this.markerValues,
        stepped: this.stepped,
        format: {
          to: value => {
            if (this.markerLabelFormatter) {
              return this.markerLabelFormatter(value, this.max, this.min);
            } else {
              return Math.round(value) + this.markerSuffix;
            }
          },
          from: value => {
            return value;
          }
        }
      },
      behaviour: this.behaviour
    };
    // this.changeDetectorRef.detectChanges();
  }
  /**
   * Registers a function called when the control value changes.
   */
  registerOnChange(fn) {
    this.onChangedCallback = fn;
  }
  /**
   * Registers a function called when the control is touched.
   */
  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }
  /**
   * Write a value to the html element
   */
  writeValue(obj) {
    if (!obj && obj !== 0) {
      return;
    }
    if (Array.isArray(obj) || !isNaN(obj)) {
      this.values = obj;
    }
    this.changeDetectorRef.detectChanges();
  }
  /**
   * every change in the value
   */
  onChanged(event) {
    this.values = event;
    this.onChangedCallback(this.values);
    this.changeDetectorRef.detectChanges();
  }
  /**
   * every change in the value
   */
  onSliderEnd(values) {
    this.endEvent.emit(values);
  }
  /**
   * every change in the value
   */
  onSliderChange(values) {
    if (this.slideTimeout) clearTimeout(this.slideTimeout);
    this.slideTimeout = setTimeout(() => {
      this.changeEvent.emit(values);
      this.slideTimeout = null;
    }, 200);
  }
  static {
    this.ɵfac = function RangeSliderComponent_Factory(t) {
      return new (t || RangeSliderComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: RangeSliderComponent,
      selectors: [["sol-range-slider"]],
      viewQuery: function RangeSliderComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.slider = _t.first);
        }
      },
      inputs: {
        max: "max",
        min: "min",
        step: "step",
        startPoints: "startPoints",
        range: "range",
        pips: "pips",
        enableTooltip: "enableTooltip",
        enableTooltipOnDrag: "enableTooltipOnDrag",
        mode: "mode",
        density: "density",
        markerValues: "markerValues",
        stepped: "stepped",
        behaviour: "behaviour",
        markerSuffix: "markerSuffix",
        markerLabelFormatter: "markerLabelFormatter",
        tooltipFormatter: "tooltipFormatter",
        connect: "connect",
        colorClasses: "colorClasses",
        highlightPosition: "highlightPosition",
        highlightedMarkerTitle: "highlightedMarkerTitle",
        disabled: "disabled",
        enableArrow: "enableArrow",
        enableRoundButton: "enableRoundButton"
      },
      outputs: {
        endEvent: "endEvent",
        changeEvent: "changeEvent"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => RangeSliderComponent),
        multi: true
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 4,
      vars: 7,
      consts: [[1, "sol-range-slider", 3, "ngClass"], ["ngDefaultControl", "", 3, "config", "ngModel", "disabled", "ngModelChange", "slide", "end"], ["slider", ""], ["class", "range-silder-pseudo", 4, "ngIf"], [1, "range-silder-pseudo"]],
      template: function RangeSliderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "nouislider", 1, 2);
          i0.ɵɵlistener("ngModelChange", function RangeSliderComponent_Template_nouislider_ngModelChange_1_listener($event) {
            return ctx.onChanged($event);
          })("slide", function RangeSliderComponent_Template_nouislider_slide_1_listener($event) {
            return ctx.onSliderChange($event);
          })("end", function RangeSliderComponent_Template_nouislider_end_1_listener($event) {
            return ctx.onSliderEnd($event);
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(3, RangeSliderComponent_span_3_Template, 1, 0, "span", 3);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1, ctx.enableTooltip && ctx.enableTooltipOnDrag));
          i0.ɵɵadvance();
          i0.ɵɵproperty("config", ctx.someKeyboardConfig)("ngModel", ctx.values)("disabled", ctx.disabled);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.slideTimeout);
        }
      },
      dependencies: [i1.NgClass, i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, i3.NouisliderComponent],
      styles: [".sol-range-slider div:focus{outline:none}.sol-range-slider .noUi-touch-area{cursor:default;position:absolute;border-radius:.188rem;color:#000000de;z-index:20}.sol-range-slider .noUi-touch-area.no-ui-touch-area-round{border-radius:50%}.sol-range-slider .noUi-touch-area.no-ui-touch-area-round:after{display:none}.sol-range-slider .noUi-touch-area.no-ui-touch-area-round:before{display:none}.sol-range-slider .noUi-touch-area:before{content:\"\";display:block;position:absolute;height:.75rem;width:.125rem;background:gray;left:.469rem;transform:translate(-50%,-50%);top:.813rem}.sol-range-slider .noUi-touch-area:after{content:\"\";display:block;position:absolute;height:.75rem;width:.125rem;background:gray;left:.781rem;transform:translate(-50%,-50%);top:.813rem}.sol-range-slider .noUi-tooltip{position:absolute;cursor:default;background-color:var(--color-interface-text800);color:var(--color-button-text-normal);border-radius:.5rem;border:.063rem solid var(--color-interface-text800);padding:.5rem .75rem;min-width:2.625rem;min-height:1.938rem;text-align:center;left:.625rem;top:-2.813rem;font-size:.75rem;font-family:var(--typography-opensans-body-body4-font-family)}.sol-range-slider .noUi-tooltip:after{background-color:var(--color-interface-text800);content:\"\";position:absolute;top:73%;left:40%;transform:rotate(45deg);width:.75rem;height:.75rem;z-index:-1}.sol-range-slider .noUi-horizontal,.sol-range-slider .noUi-tooltip{bottom:150%}.sol-range-slider.enableTooltipOnDrag .noUi-tooltip{display:none}.sol-range-slider.enableTooltipOnDrag .noUi-active .noUi-tooltip{display:block}.sol-range-slider .noUi-horizontal .noUi-handle{height:1.75rem;width:1.375rem;right:-.688rem;top:-.625rem}.sol-range-slider .noUi-horizontal .noUi-handle:after{display:none}.sol-range-slider .noUi-horizontal .noUi-handle:before{display:none}.sol-range-slider .noUi-horizontal .noUi-handle.no-ui-handler-round{border:.063rem solid var(--color-globalstate-inactive-text);box-shadow:0 .063rem .125rem #00000052;height:1.375rem;width:1.375rem;border-radius:50%;right:-.625rem;top:-.563rem}.sol-range-slider .noUi-horizontal .noUi-handle.no-ui-handler-round:focus-visible{outline:.063rem solid var(--color-globalstate-focus);outline-offset:.25rem;box-shadow:0 .063rem .063rem #00000052;height:1.75rem;width:1.75rem;right:-.875rem;top:-.75rem}.sol-range-slider .noUi-horizontal .noUi-handle.no-ui-handler-round:focus-visible .noUi-tooltip{display:block}.sol-range-slider .noUi-horizontal .noUi-handle.noUi-active{box-shadow:0 .063rem .125rem #00000052;border:.063rem solid var(--color-globalstate-inactive-text);width:1.75rem;height:1.75rem;right:-.875rem;top:-.75rem}.sol-range-slider .addGreenArrow{content:\"\";position:absolute;top:-.5rem;height:1rem;width:.5rem;border-top:.625rem solid transparent;border-bottom:.625rem solid transparent;right:-.75rem;border-left:.625rem solid var(--color-interface-success300)}.sol-range-slider .noUi-target{border:none;height:.25rem;border-right:.25rem solid var(--color-interface-border1)}.sol-range-slider .addRedArrow{content:\"\";position:absolute;top:-.5rem;height:1rem;width:.5rem;border-top:.625rem solid transparent;border-bottom:.625rem solid transparent;left:-1rem;box-sizing:border-box;border-right:.625rem solid var(--color-interface-error600)}.sol-range-slider .noUi-base{background-color:var(--color-interface-border1)}.sol-range-slider .noUi-base .noUi-connects{overflow:visible;left:-.25rem;border-left:.25rem solid var(--color-interface-border1)}.sol-range-slider .noUi-connect{height:.25rem;background:var(--color-interface-blue450)}.sol-range-slider .noUi-connect.c-1-darkRed{background:var(--color-interface-error600);height:.5rem;margin-top:-.125rem;left:-.25rem}.sol-range-slider .noUi-connect.c-2-mediumRed{background:var(--color-interface-error500);height:.375rem;margin-top:-.063rem;left:-.25rem}.sol-range-slider .noUi-connect.c-3-lightRed{height:.25rem;background:var(--color-interface-error400)}.sol-range-slider .noUi-connect.c-4-white{height:.25rem;background:var(--color-interface-border1)}.sol-range-slider .noUi-connect.c-5-lightGreen{height:.25rem;background:var(--color-interface-success200)}.sol-range-slider .noUi-connect.c-6-mediumGreen{background:var(--color-interface-success300);height:.375rem;margin-top:-.063rem}.sol-range-slider .noUi-connect.c-7-darkGreen{background:var(--color-interface-success450);height:.5rem;margin-top:-.125rem;left:.375rem}.sol-range-slider .noUi-connect.c-8-thinDarkGreen{height:.25rem;background:var(--color-interface-success300);right:-.75rem}.sol-range-slider .noUi-connect.c-9-yellow{background:var(--color-interface-warning200);height:.375rem;margin-top:-.063rem}.sol-range-slider .noUi-connect.c-10-blue{height:.25rem;background:var(--color-interface-blue450)}.sol-range-slider .noUi-connect.c-11-grey{height:.25rem;background:var(--color-interface-border1);right:-.25rem}.sol-range-slider .noUi-connect.c-blue{background:var(--color-interface-blue450)}.sol-range-slider .noUi-connect.c-grey{background:var(--color-interface-border1)}.sol-range-slider .noUi-connect:first-child{left:-.25rem}.sol-range-slider .noUi-connect:last-child{right:-.25rem}.sol-range-slider .noUi-pips{height:100%;padding-top:.125rem}.sol-range-slider .highlighted-marker-class{border-left:.125rem dotted #404040;height:2.5rem;position:absolute;top:-1.875rem;z-index:2}.sol-range-slider .highlighted-marker-title-class{position:absolute;top:-1.25rem;right:-.625rem;color:var(--color-globalstate-inactive-text);font-weight:400;font-size:.75rem}.sol-range-slider .noUi-marker.noUi-marker-large{height:.5rem;width:.125rem;background-color:var(--color-globalstate-inactive-border)}.sol-range-slider .noUi-marker.noUi-marker-normal{height:.25rem;width:.125rem;background-color:var(--color-globalstate-inactive-border)}.sol-range-slider .noUi-marker.noUi-marker-sub{height:.5rem;width:.125rem;background-color:var(--color-globalstate-inactive-border)}.sol-range-slider .noUi-value{text-align:center;font-size:.75rem;font-family:var(--typography-opensans-body-body4-font-family);font-weight:400;width:1.563rem;height:.938rem;padding-top:.125rem;color:var(--color-globalstate-inactive-text)}.sol-range-slider [disabled] .noUi-connect{background:var(--color-globalstate-disabled-borderalt)!important}.sol-range-slider [disabled] .noUi-connects{border-left:none}.sol-range-slider [disabled].noUi-target .addGreenArrow{border-left:.625rem solid var(--color-globalstate-disabled-borderalt)}.sol-range-slider [disabled].noUi-target .addRedArrow{border-right:.625rem solid var(--color-globalstate-disabled-borderalt)}.sol-range-slider [disabled].noUi-target,.sol-range-slider [disabled].noUi-handle,.sol-range-slider [disabled] .noUi-handle{cursor:not-allowed;border:.063rem solid var(--color-globalstate-disabled-borderalt)!important}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RangeSliderComponent, [{
    type: Component,
    args: [{
      selector: 'sol-range-slider',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => RangeSliderComponent),
        multi: true
      }],
      template: "<div class=\"sol-range-slider\" [ngClass]=\"{ enableTooltipOnDrag: enableTooltip && enableTooltipOnDrag }\">\n  <nouislider\n    #slider\n    ngDefaultControl\n    [config]=\"someKeyboardConfig\"\n    [ngModel]=\"values\"\n    (ngModelChange)=\"onChanged($event)\"\n    (slide)=\"onSliderChange($event)\"\n    (end)=\"onSliderEnd($event)\"\n    [disabled]=\"disabled\"\n  ></nouislider>\n</div>\n<span *ngIf=\"slideTimeout\" class=\"range-silder-pseudo\"></span>\n",
      styles: [".sol-range-slider div:focus{outline:none}.sol-range-slider .noUi-touch-area{cursor:default;position:absolute;border-radius:.188rem;color:#000000de;z-index:20}.sol-range-slider .noUi-touch-area.no-ui-touch-area-round{border-radius:50%}.sol-range-slider .noUi-touch-area.no-ui-touch-area-round:after{display:none}.sol-range-slider .noUi-touch-area.no-ui-touch-area-round:before{display:none}.sol-range-slider .noUi-touch-area:before{content:\"\";display:block;position:absolute;height:.75rem;width:.125rem;background:gray;left:.469rem;transform:translate(-50%,-50%);top:.813rem}.sol-range-slider .noUi-touch-area:after{content:\"\";display:block;position:absolute;height:.75rem;width:.125rem;background:gray;left:.781rem;transform:translate(-50%,-50%);top:.813rem}.sol-range-slider .noUi-tooltip{position:absolute;cursor:default;background-color:var(--color-interface-text800);color:var(--color-button-text-normal);border-radius:.5rem;border:.063rem solid var(--color-interface-text800);padding:.5rem .75rem;min-width:2.625rem;min-height:1.938rem;text-align:center;left:.625rem;top:-2.813rem;font-size:.75rem;font-family:var(--typography-opensans-body-body4-font-family)}.sol-range-slider .noUi-tooltip:after{background-color:var(--color-interface-text800);content:\"\";position:absolute;top:73%;left:40%;transform:rotate(45deg);width:.75rem;height:.75rem;z-index:-1}.sol-range-slider .noUi-horizontal,.sol-range-slider .noUi-tooltip{bottom:150%}.sol-range-slider.enableTooltipOnDrag .noUi-tooltip{display:none}.sol-range-slider.enableTooltipOnDrag .noUi-active .noUi-tooltip{display:block}.sol-range-slider .noUi-horizontal .noUi-handle{height:1.75rem;width:1.375rem;right:-.688rem;top:-.625rem}.sol-range-slider .noUi-horizontal .noUi-handle:after{display:none}.sol-range-slider .noUi-horizontal .noUi-handle:before{display:none}.sol-range-slider .noUi-horizontal .noUi-handle.no-ui-handler-round{border:.063rem solid var(--color-globalstate-inactive-text);box-shadow:0 .063rem .125rem #00000052;height:1.375rem;width:1.375rem;border-radius:50%;right:-.625rem;top:-.563rem}.sol-range-slider .noUi-horizontal .noUi-handle.no-ui-handler-round:focus-visible{outline:.063rem solid var(--color-globalstate-focus);outline-offset:.25rem;box-shadow:0 .063rem .063rem #00000052;height:1.75rem;width:1.75rem;right:-.875rem;top:-.75rem}.sol-range-slider .noUi-horizontal .noUi-handle.no-ui-handler-round:focus-visible .noUi-tooltip{display:block}.sol-range-slider .noUi-horizontal .noUi-handle.noUi-active{box-shadow:0 .063rem .125rem #00000052;border:.063rem solid var(--color-globalstate-inactive-text);width:1.75rem;height:1.75rem;right:-.875rem;top:-.75rem}.sol-range-slider .addGreenArrow{content:\"\";position:absolute;top:-.5rem;height:1rem;width:.5rem;border-top:.625rem solid transparent;border-bottom:.625rem solid transparent;right:-.75rem;border-left:.625rem solid var(--color-interface-success300)}.sol-range-slider .noUi-target{border:none;height:.25rem;border-right:.25rem solid var(--color-interface-border1)}.sol-range-slider .addRedArrow{content:\"\";position:absolute;top:-.5rem;height:1rem;width:.5rem;border-top:.625rem solid transparent;border-bottom:.625rem solid transparent;left:-1rem;box-sizing:border-box;border-right:.625rem solid var(--color-interface-error600)}.sol-range-slider .noUi-base{background-color:var(--color-interface-border1)}.sol-range-slider .noUi-base .noUi-connects{overflow:visible;left:-.25rem;border-left:.25rem solid var(--color-interface-border1)}.sol-range-slider .noUi-connect{height:.25rem;background:var(--color-interface-blue450)}.sol-range-slider .noUi-connect.c-1-darkRed{background:var(--color-interface-error600);height:.5rem;margin-top:-.125rem;left:-.25rem}.sol-range-slider .noUi-connect.c-2-mediumRed{background:var(--color-interface-error500);height:.375rem;margin-top:-.063rem;left:-.25rem}.sol-range-slider .noUi-connect.c-3-lightRed{height:.25rem;background:var(--color-interface-error400)}.sol-range-slider .noUi-connect.c-4-white{height:.25rem;background:var(--color-interface-border1)}.sol-range-slider .noUi-connect.c-5-lightGreen{height:.25rem;background:var(--color-interface-success200)}.sol-range-slider .noUi-connect.c-6-mediumGreen{background:var(--color-interface-success300);height:.375rem;margin-top:-.063rem}.sol-range-slider .noUi-connect.c-7-darkGreen{background:var(--color-interface-success450);height:.5rem;margin-top:-.125rem;left:.375rem}.sol-range-slider .noUi-connect.c-8-thinDarkGreen{height:.25rem;background:var(--color-interface-success300);right:-.75rem}.sol-range-slider .noUi-connect.c-9-yellow{background:var(--color-interface-warning200);height:.375rem;margin-top:-.063rem}.sol-range-slider .noUi-connect.c-10-blue{height:.25rem;background:var(--color-interface-blue450)}.sol-range-slider .noUi-connect.c-11-grey{height:.25rem;background:var(--color-interface-border1);right:-.25rem}.sol-range-slider .noUi-connect.c-blue{background:var(--color-interface-blue450)}.sol-range-slider .noUi-connect.c-grey{background:var(--color-interface-border1)}.sol-range-slider .noUi-connect:first-child{left:-.25rem}.sol-range-slider .noUi-connect:last-child{right:-.25rem}.sol-range-slider .noUi-pips{height:100%;padding-top:.125rem}.sol-range-slider .highlighted-marker-class{border-left:.125rem dotted #404040;height:2.5rem;position:absolute;top:-1.875rem;z-index:2}.sol-range-slider .highlighted-marker-title-class{position:absolute;top:-1.25rem;right:-.625rem;color:var(--color-globalstate-inactive-text);font-weight:400;font-size:.75rem}.sol-range-slider .noUi-marker.noUi-marker-large{height:.5rem;width:.125rem;background-color:var(--color-globalstate-inactive-border)}.sol-range-slider .noUi-marker.noUi-marker-normal{height:.25rem;width:.125rem;background-color:var(--color-globalstate-inactive-border)}.sol-range-slider .noUi-marker.noUi-marker-sub{height:.5rem;width:.125rem;background-color:var(--color-globalstate-inactive-border)}.sol-range-slider .noUi-value{text-align:center;font-size:.75rem;font-family:var(--typography-opensans-body-body4-font-family);font-weight:400;width:1.563rem;height:.938rem;padding-top:.125rem;color:var(--color-globalstate-inactive-text)}.sol-range-slider [disabled] .noUi-connect{background:var(--color-globalstate-disabled-borderalt)!important}.sol-range-slider [disabled] .noUi-connects{border-left:none}.sol-range-slider [disabled].noUi-target .addGreenArrow{border-left:.625rem solid var(--color-globalstate-disabled-borderalt)}.sol-range-slider [disabled].noUi-target .addRedArrow{border-right:.625rem solid var(--color-globalstate-disabled-borderalt)}.sol-range-slider [disabled].noUi-target,.sol-range-slider [disabled].noUi-handle,.sol-range-slider [disabled] .noUi-handle{cursor:not-allowed;border:.063rem solid var(--color-globalstate-disabled-borderalt)!important}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }], {
    max: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    step: [{
      type: Input
    }],
    startPoints: [{
      type: Input
    }],
    range: [{
      type: Input
    }],
    pips: [{
      type: Input
    }],
    enableTooltip: [{
      type: Input
    }],
    enableTooltipOnDrag: [{
      type: Input
    }],
    mode: [{
      type: Input
    }],
    density: [{
      type: Input
    }],
    markerValues: [{
      type: Input
    }],
    stepped: [{
      type: Input
    }],
    behaviour: [{
      type: Input
    }],
    markerSuffix: [{
      type: Input
    }],
    markerLabelFormatter: [{
      type: Input
    }],
    tooltipFormatter: [{
      type: Input
    }],
    connect: [{
      type: Input
    }],
    colorClasses: [{
      type: Input
    }],
    highlightPosition: [{
      type: Input
    }],
    highlightedMarkerTitle: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    enableArrow: [{
      type: Input
    }],
    enableRoundButton: [{
      type: Input
    }],
    endEvent: [{
      type: Output
    }],
    changeEvent: [{
      type: Output
    }],
    slider: [{
      type: ViewChild,
      args: ['slider', {
        static: false
      }]
    }]
  });
})();
class RangeSliderModule {
  static {
    this.ɵfac = function RangeSliderModule_Factory(t) {
      return new (t || RangeSliderModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: RangeSliderModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, ReactiveFormsModule, NouisliderModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RangeSliderModule, [{
    type: NgModule,
    args: [{
      declarations: [RangeSliderComponent],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, NouisliderModule],
      exports: [RangeSliderComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of range-slider
 */

/**
 * Generated bundle index. Do not edit.
 */

export { RangeSliderComponent, RangeSliderModule };
